import type { FC } from 'react';

import type { BlockLibraryListProps } from '../components';
import { BlocksLibraryList } from '../components';

import type { BlocksCountProps } from './BlocksCount';
import { BlocksCount } from './BlocksCount';

interface BlockLibraryListSuccessProps extends BlockLibraryListProps, BlocksCountProps {}

export const BlockLibraryListSuccess: FC<BlockLibraryListSuccessProps> = ({
  count,
  total,
  ...blockLibraryListProps
}) => {
  return (
    <>
      <div className="text-info-700 flex flex-col gap-2 text-xs!">
        <BlocksLibraryList {...blockLibraryListProps} total={total} className="col-span-4 h-full overflow-y-auto" />
      </div>
      <BlocksCount count={count} total={total} />
    </>
  );
};
